module.exports = __webpack_public_path__ + "static/media/card-aluno.45aba4bf.png";